module.exports = __webpack_public_path__ + "static/grbmember3-3e4c7d8e84077a82025afbb711c2ec06.svg";